import { useQuery } from "@apollo/client/react";
import type { ClientModel } from "../../../models/ClientModel";
import GET_CLIENT_TEMPLATES from "../../queries/documentHandler/getClientTemplates";

export const useClientTemplates = (clientIdentifier: string) => {
  const { data, error, loading, refetch } = useQuery<{ client: ClientModel }>(
    GET_CLIENT_TEMPLATES,
    {
      variables: {
        clientIdentifier: clientIdentifier,
      },
    }
  );
  return { client: data?.client, error, loading, refetch };
};
